import { useSelector } from 'react-redux';
import { ILineResource } from '../../entities/farms.entities';
import { IGrowingSeed } from '../../entities/growing.entities';
import { defaultDateFormat } from '../../lib/common.helpers';
import { lineLengthLabel } from '../../lib/farm.helpers';
import { Dropdown } from '../shared';
import { selectAccount } from '../../store/auth/auth.selector';

interface Props {
  label: string;
  lineData: ILineResource;
  seedings: IGrowingSeed[];
  value?: number | null;
  onChange: (value: number | null) => void;
}

const SelectBatchSeed = ({
  label,
  lineData,
  seedings,
  value,
  onChange,
}: Props) => {
  const displayUnit = useSelector(selectAccount)?.display_unit;

  const options = [
    { id: 'null', value: '', label: 'None' },
    ...seedings.map(s => ({
      id: s.id.toString(),
      value: s.id.toString(),
      label: `${s.spat_source} - ${lineLengthLabel(lineData.crop_type, lineData.line_type, lineData.farming_method, displayUnit, s.line_length ?? s.basket_count)} (${defaultDateFormat(s.planned_date_seed)})`,
    })),
  ];

  const changeOption = (v: string) => {
    if (!v) {
      onChange(null);
    } else {
      const batch = seedings.find(b => b.id.toString() === v);
      if (batch) {
        onChange(batch.id);
      }
    }
  };

  return (
    <Dropdown
      label={label}
      options={options}
      value={value === null ? '' : value?.toString() || undefined}
      onChange={v => changeOption(v)}
    />
  );
};

export default SelectBatchSeed;
